export const lightTheme = {
  background: '#ACE1AF',
  color: '#005842',
  accentColor: '#005842',
  chronoTheme: {
    cardBgColor: '#C5FCC8',
    cardForeColor: 'black',
    titleColor: 'black',
  },
  timelineLineColor: '#005842',
  cardBackground: '#BAF7BD',
  cardFooterBackground: '#C5FCC8',
  cardBorderColor: '#C5FCC8',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'light',
  bsSecondaryVariant: 'dark',
  socialIconBgColor: '#005842',
};

export const darkTheme = {
  background: '#005842',
  color: '#ACE1AF',
  accentColor: '#ACE1AF',
  chronoTheme: {
    cardBgColor: '#1A2421',
    cardForeColor: 'white',
    titleColor: 'white',
  },
  timelineLineColor: '#ACE1AF',
  cardBackground: '#18453B',
  cardFooterBackground: '#1A2421',
  cardBorderColor: '#1A2421',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'dark',
  bsSecondaryVariant: 'light',
  socialIconBgColor: '#ACE1AF',
};
